import { render, staticRenderFns } from "./CaseMedications.vue?vue&type=template&id=60ef737f&scoped=true&"
import script from "./CaseMedications.vue?vue&type=script&lang=js&"
export * from "./CaseMedications.vue?vue&type=script&lang=js&"
import style0 from "./CaseMedications.vue?vue&type=style&index=0&id=60ef737f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef737f",
  null
  
)

export default component.exports